import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { resizeImage } from "@/lib/photoUpload";

// Re-uploads a lost photo into its original slot (also heals shared-link copies).
export const ReplacePhotoButton = ({ photo, onReplaced, testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const [full, thumb] = await Promise.all([resizeImage(file, 1600, 0.82), resizeImage(file, 400, 0.7)]);
      const fd = new FormData();
      fd.append("full", full.blob, "full.webp");
      fd.append("thumb", thumb.blob, "thumb.webp");
      const { data } = await api.raw.post(`/photos/${photo.id}/replace`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onReplaced(data);
      toast.success(data.healed ? `Photo restored here and in ${data.healed} shared link${data.healed === 1 ? "" : "s"}` : "Photo restored");
    } catch {
      toast.error("Couldn't replace photo — try again");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId}
        className="mt-1 inline-flex items-center gap-1 rounded-full bg-emerald-500 px-3 py-1.5 text-[11px] font-semibold text-white transition-transform active:scale-95 disabled:opacity-60">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCw className="h-3 w-3" />} Replace
      </button>
      <input ref={ref} type="file" accept="image/*" hidden onChange={pick} data-testid={`${testId}-input`} />
    </>
  );
};
